<template>
    <div>
        <p class="text-center mb-0">{{unidadeSelecionada.cnes}} - {{unidadeSelecionada.nome}}</p>
        <p class="text-center mb-0"><strong>Enfermaria:</strong> {{dados.leitoCodigoEnfermaria}} <strong>Leito:</strong> {{dados.leitoCodigo}}</p>
        <p class="text-center"><strong>{{dados.leitoNomeEnfermaria}}</strong></p>
        
        <div class="row">
            <div class="col-sm-12 form-group">
                 <label>Nome</label>
                 <input class="form-control" :value="dados.pacienteNome" disabled>
            </div>
        </div>
        
        <div class="row">
             <div class="col-sm-4 form-group">
                 <label>CNS</label>
                 <input class="form-control" :value="dados.pacienteCns" disabled>
            </div>

            <div class="col-sm-3 form-group">
                 <label>Data de Nascimento</label>
                 <input class="form-control" :value="dados.pacienteDataNascimento" disabled>
            </div>

             <div class="col-sm-2 form-group">
                <label>Idade</label>
                <input class="form-control" :value="dados.pacienteIdade" disabled>
            </div>

            <div class="col-sm-3 form-group">
                <label>Sexo</label>
                <select type="text" class="form-control" :value="dados.pacienteSexo"  disabled>
                    <option value="1">Masculino</option>
                    <option value="2">Feminino</option>
                </select>
            </div>
        </div>

        <div class="row">
            <div class="col-sm-4 form-group">
                <label>Data/Hora Internação</label>
                <input class="form-control" :value="dados.DataHoraInternacao" disabled>
            </div>
            <div class="col-sm-4 form-group">
                <label>Data/Hora Internação Leito</label>
                <input class="form-control" :value="dados.dataHoraInternacaoLeito" disabled>
            </div>
             <div class="col-sm-4 form-group">
                <label>Caso de Óbito</label>
                <select type="text" class="form-control" v-model="obito">
                    <option value="0">Não</option>
                    <option value="1">Sim</option>
                </select>
                <small v-if="obito == ''" class="text-danger">preenchimento obrigatório</small>
            </div>
        </div>

        <div class="row" v-if="obito == 1">
            <div class="col-sm-4 form-group" >
                <label>Número da Declaração de Óbito</label>
                <input class="form-control" v-model="declaracao" v-mask="'##############################'">
                <small v-if="declaracao == ''" class="text-danger">preenchimento obrigatório</small>
            </div>  
        </div>

        <div class="row">
            <div class="col-sm-4 form-group">
                <label>Receber aviso por e-mail</label>
                <select type="text" class="form-control" v-model="email">
                    <option value="" disabled>Selecione</option>
                    <option value="0">Não</option>
                    <option value="1">Sim</option>
                </select>
                <small v-if="email === ''" class="text-danger">preenchimento obrigatório</small>
            </div>

            <div class="form-group col-sm-8">
                <label for="unidade">Procedimento</label>
                <multiselect
                    :options="listaProcedimentos"
                    track-by="procedimento"
                    label="procedimento"
                    :searchable="true"
                    placeholder="Pesquise e selecione"
                    selectLabel="+"
                    deselectLabel="-" 
                    selectedLabel="selecionado"
                    v-model="procedimento"
                    >

                    <span slot="noResult">Nenhum resultado encontrado.</span>
                </multiselect>
                <small v-if="procedimento == '' || procedimento == null" class="text-danger">preenchimento obrigatório</small>
            </div>
        </div>

        <div class="row">
            <div class="form-group col-sm-6">
                <label for="unidade">CID Primário</label>
                <multiselect
                    :options="listaCid"
                    track-by="cid"
                    label="cid"
                    :searchable="true"
                    placeholder="Pesquise e selecione"
                    selectLabel="+"
                    deselectLabel="-" 
                    selectedLabel="selecionado"
                    v-model="cidprimario"
                    >

                    <span slot="noResult">Nenhum resultado encontrado.</span>
                </multiselect>
                <small v-if="cidprimario == '' || cidprimario == null" class="text-danger">preenchimento obrigatório</small>
            </div>

            <div class="form-group col-sm-6">
                <label for="unidade">CID Secundário</label>
                <multiselect
                    :options="listaCid"
                    track-by="cid"
                    label="cid"
                    :searchable="true"
                    placeholder="Pesquise e selecione"
                    selectLabel="+"
                    deselectLabel="-" 
                    selectedLabel="selecionado"
                    v-model="cidsecundario"
                    >

                    <span slot="noResult">Nenhum resultado encontrado.</span>
                </multiselect>
            </div>
        </div>

        <div class="bordas" v-if="dados.aih">
            <h5 class="text-center font-weight-bold text-primary mb-3">Lista de AIHs geradas para esta internação</h5>
            <p class="text-center text-danger font-weight-bold" v-for="(aih, index) in dados.aih" :key="index">{{aih.numeroAih}} - {{aih.statusAih}}</p>
        </div>

        <button type="button" class="btn btn-primary" :disabled="desabilitaBtn" @click="validaSessao('gerarAih')">Gerar <span v-if="dados.aih">Nova</span> AIH</button>

    </div>
</template>

<script>
import { validaSessao } from '../../../shared/mixins/validaSessao'

export default {
    props: {
        dados: Object
    },
    mixins: [
        validaSessao
    ],
    computed: {
        unidadeSelecionada () {
            return this.$store.getters['filtro/getUnidadeSelecionada']
        },
        listaProcedimentos () {
            return this.$store.getters['consultas/getListaProcedimentos']
        },
        listaCid () {
            return this.$store.getters['consultas/getListaCid']
        }
    },
    data () {
        return {
            procedimento: '',
            cidprimario: '',
            cidsecundario: '',
            obito: '0',
            declaracao: '',
            email: '0',

            desabilitaBtn: false
        }
    },
    methods: {
        gerarAih () {
            this.desabilitaBtn = true
            if (this.procedimento === '') {
                this.desabilitaBtn = false
                return
            } 
            if (this.cidprimario === '' || this.cidprimario === null) {
                this.desabilitaBtn = false
                return
            }
            if (this.obito == '1' && this.declaracao == '') {
                this.desabilitaBtn = false
                return
            }

            let dados = {
                cids: '',
                cns: this.dados.pacienteCns,
                doObito: this.declaracao,
                recebimentoEmail: parseInt(this.email),
                codigoEnfermaria: this.dados.leitoCodigoEnfermaria,
                codigoLeito: this.dados.leitoCodigo,
                internacaoId: this.dados.internacaoId
            }

            let arrayprocedimento = this.procedimento.procedimento.split(' ');
            dados.codigoProcedimento = arrayprocedimento[0]

            let arraycidprimario = this.cidprimario.cid.split(' ');
            dados.cidp = arraycidprimario[0]

            if (this.cidsecundario !== '' && this.cidsecundario !== null) {
                let arraycidsecundario = this.cidsecundario.cid.split(' ');
                dados.cids = arraycidsecundario[0]
            }           

            this.$emit('geraraih', dados)
        }
    }
}
</script>